import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Backend = () => {
  // Настройки слайдера
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    centerPadding: '20px',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: '20px',
          variableWidth: false,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: '20px',
          variableWidth: false,
        },
      },
      {
        breakpoint: 768, // Планшеты
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 450, // Мобильные устройства
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  }

  return (
    <section className="backend_section">
      <div className="bs_container">
        <h2 className="bs_title">Backend portfolio</h2>
        <div className="bs_project_card_container">
          <Slider {...settings}>
            <div className="bs_project_card">
              <div className="card-img order-management-img">
                <h3>Order Management App</h3>
                <div className="bs_project_descr">
                  <p>
                    Full-featured order management application that allows users
                    to browse products, create orders and manage their
                    purchases.
                  </p>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://github.com/MaksymChukhrai/order-management-app/blob/main/README.md"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Full description
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/order-management-app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>

            <div className="bs_project_card">
              <div className="card-img bank-trans-img">
                <h3>Banking Transactions API</h3>
                <div className="bs_project_descr">
                  <p>
                    API for working with banking transactions
                  </p>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://github.com/MaksymChukhrai/backend-bank-operations/blob/main/README.md"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Full description
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/backend-bank-operations"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>

            <div className="bs_project_card">
              <div className="card-img currency-exchange-img">
                <h3>NBU Currency Exchange App</h3>
                <div className="bs_project_descr">
                  <p>
                    TypeScript-based currency exchange application featuring real-time NBU rates, modern React UI with comprehensive validation.
                  </p>
                </div>
              </div>

              <div className="bs_project_button_container">
                <a
                  href="https://github.com/MaksymChukhrai/express-currency-converter/blob/main/README.md"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_descr"
                >
                  Full description
                </a>

                <a
                  href="https://github.com/MaksymChukhrai/express-currency-converter"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bs_project_button_repo"
                >
                  Repository
                </a>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default Backend
